import { Flex, Box, Text, VStack, Image } from '@chakra-ui/react';
import ChakraMarkdown from '../ChakraMarkdown';
import Button from '../CustomButton';
import Link from 'next/link';

const Partners = ({ item }) => {
  return (
    <Flex alignItems="center" justifyContent="space-around">
      <Flex w={298} h={200} justifyContent="center" alignItems="center">
        <Image
          src={item.attributes.logo.data.attributes.url}
          width={item.attributes.logo.data.attributes.width}
          height={item.attributes.logo.data.attributes.height}
          alt={item.attributes.logo.data.attributes.name}
          style={{ objectFit: 'contain' }}
        />
      </Flex>
      <Box p="1rem" maxW="60%">
        <Text fontSize="1.1rem" fontWeight={600}>
          {item.attributes.company}
        </Text>
        <ChakraMarkdown
          content={item.attributes.shortDescription}
          onLinkClick={() => null}
        />
      </Box>
      <VStack>
        {item.attributes.showcase !== null &&
          item.attributes.showcase.content && (
            <Link
              href={`/partners/${item.attributes.url}`}
              style={{ textDecoration: 'none' }}
            >
              <Button
                title="Showcase"
                backgroundColor="#CF0032"
                size="sm"
                maxWidth="8rem"
              />
            </Link>
          )}
        <Link href={`/contact`} style={{ textDecoration: 'none' }}>
          <Button
            title="Contact"
            backgroundColor="#868e96"
            size="sm"
            margin="10px 0"
            maxWidth="8rem"
          />
        </Link>
      </VStack>
    </Flex>
  );
};

export default Partners;
